import { render } from "./MusicList.vue?vue&type=template&id=bf56339a&scoped=true"
import script from "./MusicList.vue?vue&type=script&lang=js"
export * from "./MusicList.vue?vue&type=script&lang=js"

import "./MusicList.vue?vue&type=style&index=0&id=bf56339a&scoped=true&lang=css"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf56339a"]])

export default __exports__